module.exports = "./img/7f1cc0b8901725fd88fc2bcd9d1881a7.jpg";